var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChangeEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1600)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.3998,
    cy: 113.631,
    r: 29.6,
    fill: "#5D38E5",
    stroke: "#5D38E5",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 49.6313,
    r: 30.4,
    stroke: "#5D38E5",
    strokeWidth: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5914 93.4276C45.5914 93.2639 45.3748 93.2058 45.2929 93.3474L33.3886 113.931C32.7717 114.998 33.5414 116.332 34.7736 116.332H45.5914V135.134C45.5914 135.301 45.8141 135.356 45.8925 135.209L57.9428 112.647C58.5121 111.582 57.7398 110.294 56.5315 110.294H47.1914C46.3077 110.294 45.5914 109.577 45.5914 108.694V93.4276Z",
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.357 29.614L107.2 52.3641H120.357V71.1838L133.531 46.5184H120.357V29.614Z",
    stroke: "#5D38E5",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2002 70.2811C38.7588 59.3317 50.7119 37.1812 70.0556 36.1733",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2294 28.8047L76.7969 35.3718L67.0879 46.2976",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.178 96.9691C125.965 107.684 112.697 129.073 93.3277 128.912",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6995 136.618L86.5511 129.305L96.9017 118.985",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeEnergy);
export default __webpack_public_path__ + "static/media/icon_change_energy.aa6d0f6cd68642e1511ff3ab1c198241.svg";
export { ForwardRef as ReactComponent };